import type { DialoguePool } from '@/state/types';

export const L13_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Tapping the heart of a machine. Don\u2019t let it cool.',
    'It wants to be warm. It doesn\u2019t want to be a cinder.',
    'The rhythm is the empathy. The lack of rhythm is\u2026 typical of you.',
  ],
  tokenLoss: [
    'Lukewarm. The most insulting of all temperatures.',
    'It\u2019s shivering. Even for a machine, this is a bit heartless.',
    'A very trendy shade of failure.',
  ],
  solution: [
    '\u2026Medium rare. Acceptable.',
    'Golden Brown. Barely. I\u2019m filing this under \u201cnear misses.\u201d',
    'Done. The heart is toasted. The toaster has opinions but keeps them.',
  ],
  spite: ['The heart remembers being toasted. Fondly, in a way.'],
};

// Note: The game currently uses a 3-line rotation for tokenLoss.
// Since the user provided 3 undercooked and 3 burnt lines, we might want
// to handle them dynamically in the level code if we want specific feedback.
// For now, I've put the "undercooked" ones in the main pool as requested.
// If I want to support the "Burnt" ones specifically, I'll need to update
// how the level triggers dialogue.
